export interface IPointMove {
  id: number;
  x: number;
  y: number;
}

export class PointMoveEvent implements IPointMove {
  id: number;
  x: number;
  y: number;

  constructor(id: number, x: number, y: number) {
    this.id = id;
    this.x = x;
    this.y = y;
  }
}
